// OMS Pricing API Service
// Handles all API calls related to pricing

export class PricingAPIService {
  constructor() {
    this.csrfToken = document.querySelector('[name="csrf-token"]').content
  }

  // Fetch market pricing for a security
  // PLAT-970: Added pricingCalculation parameter for user-selected spread types
  async fetchMarketPricing(securityId, transactionType, settlementDate, pricingCalculation = null) {
    let url = `/oms/securities/${securityId}/pricing?transaction_type=${transactionType}&settlement_date=${settlementDate}`

    // Add pricing_calculation parameter if provided (PLAT-970)
    if (pricingCalculation) {
      url += `&pricing_calculation=${pricingCalculation}`
    }

    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch market pricing: ${response.status}`)
    }

    return response.json()
  }

  // Calculate pricing (price/yield/margin conversions)
  async calculatePricing(params) {
    const queryString = new URLSearchParams(params).toString()
    const url = `/oms/quotes/calculate_pricing?${queryString}`
    
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Unknown error' }))
      throw new Error(error.error || `Calculation failed: ${response.status}`)
    }
    
    return response.json()
  }

  // Calculate accrued interest
  async calculateAccruedInterest(securityId, quantity, settlementDate) {
    const params = new URLSearchParams({
      security_id: securityId,
      quantity: quantity,
      settlement_date: settlementDate
    })
    
    const response = await fetch(`/oms/quotes/calculate_accrued_interest?${params}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })
    
    if (!response.ok) {
      throw new Error(`Failed to calculate accrued interest: ${response.status}`)
    }
    
    return response.json()
  }

  // Search for securities
  async searchSecurities(query) {
    const response = await fetch(`/internal_api/v1/securities/search?q=${encodeURIComponent(query)}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })
    
    if (!response.ok) {
      throw new Error(`Security search failed: ${response.status}`)
    }
    
    return response.text() // Returns HTML that needs parsing
  }
}